<script lang="ts">
  import { getContext } from 'svelte';
  import type { PlayerStateContext } from '../types/player-state';
  import { formatTime } from '../utils/format-time.js';

  export let withAdClipCounter = true;

  const { adClip, commercialPlaying, currentTime, indexOfCurrentCommercialAdClip, numberOfCommercialAdClips } =
    getContext<PlayerStateContext>('playerState');

  $: timeLeft = $adClip && Math.ceil(Math.max(0, $adClip.duration - $currentTime));
</script>

<div class="ad-indicator">
  <span class="ad-declaration">Werbung</span>
  {#if withAdClipCounter && $commercialPlaying && $numberOfCommercialAdClips > 0}
    <span class="ad-clip-counter">
      {$indexOfCurrentCommercialAdClip} von {$numberOfCommercialAdClips}
    </span>
  {/if}
  {#if typeof timeLeft === 'number'}
    <span class="ad-clip-time" data-testid="time-ad">
      {formatTime(timeLeft)}
      <span class="ad-clip-time-label"> verbleibend</span>
    </span>
  {/if}
</div>

<style module>
  .ad-indicator {
    display: flex;
    align-items: center;

    line-height: 1;
    font-size: 0.75em;
    font-variant-numeric: tabular-nums;
    /* set a text shadow to increase the contrast */
    text-shadow: 0 0 4px rgba(0, 0, 0, 0.75);
    white-space: nowrap;
  }

  .ad-declaration {
    font-weight: 700;
    letter-spacing: 0.03em;
  }

  .ad-clip-time::before,
  .ad-clip-counter::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: currentColor;
    margin: 0 0.5em 0.25em;
  }

  .ad-clip-time-label {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    white-space: nowrap;
    opacity: 0;
  }

  @media (prefers-contrast: more) {
    /* The advertisement layer already adds a contrasting background, so we
     * don't need the text shadow anymore. */
    .ad-indicator {
      text-shadow: none;
    }
  }
</style>
